import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../Style/VerticalService.css';

import img1 from "../utils/rb_2147940858.webp";
import img2 from "../utils/2971901-removebg-preview.webp";
import img3 from "../utils/WhatsApp_Image_2024-12-24_at_11.25.00_0879d3e3-removebg-preview.webp";
import img4 from "../utils/sideimg2.webp";
import img5 from "../utils/rb_2149383352.webp";
import img6 from "../utils/WhatsApp_Image_2024-12-24_at_11.25.00_c6abdfa5-removebg-preview.webp";
import img7 from "../utils/rb_2147940581.webp";
import img8 from "../utils/121936-OQ1QJU-804-removebg-preview.webp";
import img9 from "../utils/AiMl-removebg-preview.webp";
import img10 from "../utils/DataScience.webp";

gsap.registerPlugin(ScrollTrigger);

const services = [
  {
    title: "Web Development",
    content: "Our web development services are designed to create engaging, user-friendly, and high-performing websites.",
    link: "/web-development",
    image: img1
  },
  {
    title: "Mobile Development", 
    content: "We specialize in creating apps that run seamlessly on a wide range of Android devices, ensuring a consistent and enjoyable user experience.",
    link: "/mobile-development",
    image: img2
  },
  {
    title: "Cloud Services",
    content: "Leverage the power of the cloud with our robust cloud services. We offer tailored solutions that include cloud infrastructure setup, migration, maintenance, and optimization.",
    link: "/cloud-services",
    image: img3
  },
  {
    title: "Product Development",
    content: "We take your ideas from concept to reality with our comprehensive product development services.",
    link: "/product-development", 
    image: img4
  },
  {
    title: "Hw-sw integration",
    content: "We excel in integrating hardware and software to create cohesive, high-performing systems. Our expertise spans across various hardware platforms and software environments, enabling us to deliver solutions that are efficient, reliable, and scalable.",
    link: "/hw-sw-integration",
    image: img5
  },
  {
    title: "Staffing Solution",
    content: "Our staffing solutions provide businesses with the right talent at the right time. We specialize in sourcing, recruiting, and placing highly skilled professionals across various domains.",
    link: "/staffing-solution",
    image: img6
  },
  {
    title: "UI/UX Design", 
    content: "We craft exceptional user experiences through intuitive UI/UX design. Our design process is user-centric, focusing on creating interfaces that are not only visually appealing but also easy to navigate and use",
    link: "/ui-design",
    image: img7
  },
  {
    title: "IoT Development",
    content: "We take your ideas from concept to reality with our comprehensive product development services.",
    link: "/iot-development",
    image: img8
  },
  {
    title: "AI / ML Development",
    content: "We build intelligent solutions — from predictive models and NLP pipelines to computer vision and recommendation systems — turning data into actionable insights and scalable products.",
    link: "/ai-ml-development",
    image: img9
  },
  {
    title: "Data Science",
    content: "We harness the power of data through advanced analytics, statistical modeling, and visualization to uncover insights that drive smarter business decisions.",
    link: "/data-science", 
    image: img10
  }
];

const ServiceSection = () => {
  const containerRef = useRef(null);
  const cardsRef = useRef([]);

  useEffect(() => {
    const cards = cardsRef.current.filter(Boolean);
    const isMobile = window.innerWidth <= 768;
    
    cards.forEach((card, index) => {
      const isLeft = index % 2 === 0;
      
      if (isMobile) {
        // Mobile: Simple fade with slight movement
        gsap.set(card, { opacity: 0, y: 40 });
        
        ScrollTrigger.create({
          trigger: card,
          start: "top 85%",
          end: "bottom 20%",
          onEnter: () => {
            gsap.to(card, {
              opacity: 1,
              y: 0,
              duration: 0.4,
              ease: "power1.out"
            });
          },
          onLeave: () => {
            gsap.to(card, {
              opacity: 0.3,
              duration: 0.3
            });
          },
          onEnterBack: () => {
            gsap.to(card, {
              opacity: 1,
              y: 0,
              duration: 0.4
            });
          }
        });
      } else {
        // Desktop: Smooth side animations
        gsap.set(card, {
          opacity: 0,
          x: isLeft ? -60 : 60,
          scale: 0.9
        });
        
        ScrollTrigger.create({
          trigger: card,
          start: "top 80%",
          end: "bottom 20%",
          onEnter: () => {
            gsap.to(card, {
              opacity: 1,
              x: 0,
              scale: 1,
              duration: 0.6,
              ease: "power1.out"
            });
          },
          onLeave: () => {
            gsap.to(card, {
              opacity: 0.2,
              x: isLeft ? 30 : -30,
              duration: 0.4
            });
          },
          onEnterBack: () => {
            gsap.to(card, {
              opacity: 1,
              x: 0,
              scale: 1,
              duration: 0.5
            });
          },
          onLeaveBack: () => {
            gsap.to(card, {
              opacity: 0,
              x: isLeft ? -60 : 60,
              scale: 0.9,
              duration: 0.4
            });
          }
        });
      }
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <div className="long-vertical-services" ref={containerRef}>
      <div className="services-container">
        <h1 className="services-main-title">Our Professional Services</h1>
        <div className="center-timeline"></div>
        
        {services.map((service, index) => (
          <div 
            key={index}
            ref={el => cardsRef.current[index] = el}
            className={`service-item ${index % 2 === 0 ? 'left-align' : 'right-align'}`}
            style={{ opacity: 1 }}

          >
            <div className="service-card">
              <div className="service-content">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.content}</p>
                <Link to={service.link}>
                  <button className="service-btn">Read More</button>
                </Link>
              </div>
              <div className="service-image">
                <img src={service.image} alt={service.title} />
              </div>
            </div>
            <div className="timeline-dot"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceSection;